import request from '../utils/request'
import otherRequest from '../utils/other-request'

import authServices from './auth'
import coreServices from './core'
import Cookies from 'js-cookie'
import global from '../config/global'

import {
  getRouterByLocation
} from '../utils/common'

function update_account_info(data) {
  Cookies.set('account_info', JSON.stringify(data))
}

function account_info() {
  try {
    return JSON.parse(Cookies.get('account_info'))
  } catch (_) {
    return null
  }
}

async function check_exist() {
  let exist = false
  const currentPage = getRouterByLocation(window.location) || { name: '' }
  try {
    const response = await request({
      url: global.endpoint.USERS_EXIST,
      method: 'get',
    })
    exist = response.exist
  } catch (error) {
    exist = false;
    if (error?.response?.data?.code == '0010') {
      if (['SETTING_DB'].includes(currentPage.name)) {
        return
      }
      global.navigate('SETTING_DB', {})
      return
    }
  }
  let isAdminRouter = !!global.routers.ADMIN_ROUTERS.find(r => r.name === currentPage?.name)
  if (exist) {
    if (['AUTHENTICATE'].includes(currentPage.name)) {
      return
    }
    if (isAdminRouter && currentPage.name !== 'ADMIN_ERROR') {
      global.navigate('SIGN_IN', {}, { return_url: encodeURIComponent(`${window.location.pathname}${window.location.search}`) })
    } else {
      global.navigate('SIGN_IN', {})
    }
  } else {
    global.navigate('SIGN_UP', {})
  }
}

async function sign_up(data = {
  username,
  password,
  confirm_password,
  kdf,
  kdf_iterations,
  kdf_memory,
  kdf_parallelism,
}) {
  const payload = await coreServices.auth_payload(data)
  return request({
    url: global.endpoint.USERS_REGISTER,
    method: 'post',
    data: {
      ...payload,
      client_id: 'web',
      device_id: authServices.device_id(),
      device_name: global.jsCore.platformUtilsService.getDeviceString()
    }
  })
}

async function update(data = {}) {
  return request({
    url: global.endpoint.USERS_ME,
    method: 'put',
    data: data
  })
}

async function prelogin(data = { email: '' }) {
  return request({
    url: global.endpoint.USERS_PRELOGIN,
    method: 'post',
    data: data
  })
}

async function change_password(data = {
  password,
  kdf,
  kdf_iterations,
  kdf_memory,
  kdf_parallelism,
  is_check_password
}, newData = {
  password,
  confirm_new_password,
  kdf,
  kdf_iterations,
  kdf_memory,
  kdf_parallelism
}) {
  const username = account_info().username
  const storedKeyHash = await global.jsCore.cryptoService.getKeyHash() || null;

  const makeKey = data.password ? await coreServices.make_key(
    username,
    data.password,
    data.kdf,
    data.kdf_iterations,
    data.kdf_memory,
    data.kdf_parallelism
  ) : null
  const passwordHash = data.password ? await global.jsCore.cryptoService.hashPassword(data.password, makeKey) : storedKeyHash

  const newMakeKey = await coreServices.make_key(
    username,
    newData.password,
    newData.kdf,
    newData.kdf_iterations,
    newData.kdf_memory,
    newData.kdf_parallelism
  )
  const newPasswordHash = await global.jsCore.cryptoService.hashPassword(newData.password, newMakeKey);
  const confirmNewPasswordHash = await global.jsCore.cryptoService.hashPassword(newData.confirm_new_password, newMakeKey)

  let payload = {
    password: passwordHash,
    new_password: newPasswordHash,
    confirm_new_password: confirmNewPasswordHash,
    kdf: newData.kdf,
    kdf_iterations: newData.kdf_iterations,
    kdf_memory: newData.kdf_memory,
    kdf_parallelism: newData.kdf_parallelism
  }
  const existingEncKey = await global.jsCore.cryptoService.getEncKey();
  if (existingEncKey) {
    const encKey = await global.jsCore.cryptoService.remakeEncKey(newMakeKey);
    payload = {
      ...payload,
      new_key: encKey[1].encryptedString,
    }
  } else {
    const encKey = await global.jsCore.cryptoService.makeEncKey(newMakeKey);
    const keys = await global.jsCore.cryptoService.makeKeyPair(encKey[0])
    payload = {
      ...payload,
      is_check_password: data.is_check_password,
      new_key: encKey[1].encryptedString,
      new_public_key: keys[0],
      new_private_key: keys[1].encryptedString,
    }
  }

  return request({
    url: global.endpoint.USERS_CHANGE_PASSWORD,
    method: 'post',
    data: payload
  })
}

async function factor2() {
  return request({
    url: global.endpoint.USERS_ME_FACTOR2,
    method: 'get'
  })
}

async function active2fa(data) {
  return request({
    url: global.endpoint.USERS_ME_FACTOR2_SMART_OTP,
    method: 'put',
    data
  })
}

async function get_account() {
  return request({
    url: global.endpoint.USERS_ME,
    method: 'get',
  })
}

async function get_prelogin() {
  return request({
    url: global.endpoint.USERS_ME_PRELOGIN,
    method: 'get',
  })
}

function upload_avatar(userId, data) {
  const formData = new FormData()
  Object.keys(data).forEach(key => {
    formData.append(key, data[key])
  })
  return otherRequest({
    url: global.endpoint.USERS_ME_UPLOAD_AVATAR.replace(':user_id', userId),
    method: 'post',
    data: formData
  })
}

export default {
  check_exist,
  sign_up,
  update,
  prelogin,
  account_info,
  update_account_info,
  change_password,
  factor2,
  active2fa,
  get_account,
  get_prelogin,
  upload_avatar
}
